const API_URLS = {
    'BASE_API_URL': import.meta.env.VITE_APP_BASE_API_URL,
    'COLLECTIONS': {
        'GET': '/cartario/collections/',
        'POST': '/cartario/collections/',
        'PUT': '/cartario/collections/:public_id/',
    },
}

export default API_URLS;